<script lang="ts">
	interface Props {
		strokeColor?: string
	}

	let { strokeColor = "black" }: Props = $props()
</script>

<svg
	width="250"
	height="250"
	viewBox="0 0 250 250"
	fill="none"
	xmlns="http://www.w3.org/2000/svg"
>
	<path
		class="svg-stroke"
		d="M22 130H228"
		stroke={strokeColor}
		stroke-width="40"
		stroke-linecap="round"
	/>
	<path
		class="svg-stroke"
		d="M22 201H228"
		stroke={strokeColor}
		stroke-width="40"
		stroke-linecap="round"
	/>
	<path
		class="svg-stroke"
		d="M22 59H228"
		stroke={strokeColor}
		stroke-width="40"
		stroke-linecap="round"
	/>
</svg>

<style>
</style>
